export const swalSubmit= {
    title: "",
    text: "Παρακαλούμε επιβεβαιώστε την καταχώρηση σας",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Ναι",
    cancelButtonText: "Οχι",
}